import React, { Fragment } from 'react';
import CloseIcon from '@material-ui/icons/Close';
import { Box, IconButton, Typography, Button } from '@material-ui/core';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { colors } from 'theme/color-palette';
import previewTableStyles from './PreviewTable.style';
import ErrorOccurred from 'components/Shared/ErrorOccurred';
import { Bogle_Medium } from 'constants/constant';

const Alert = ({ onClose, isError, alertList, isRightPanelOpened, drawerWidth }) => {
	const classes = previewTableStyles();

	const PrintAlertMsg = ({ item }) => {
		return (
			<Box
				className={classes.msgBox}
				style={{
					background: isError ? colors.WARNING_COLOR : colors.ALERT_BG,
					width: isRightPanelOpened ? `calc(100% - ${drawerWidth + 30}px)` : `calc(100% - 40px)`
				}}>
				<Box style={{ display: 'flex', alignItems: 'center' }}>
					<ErrorOutlineIcon style={{ color: colors.PURPLE, marginRight: 10 }} />
					<Typography style={{ fontSize: 14 }}>{item.msg}</Typography>
				</Box>
				<Box style={{ display: 'flex' }}>
					{item.actionBtn && (
						<Button
							onClick={item.cbHandler}
							style={{
								color: colors.PURPLE,
								fontWeight: 'bold',
								fontFamily: Bogle_Medium,
								width: 'max-content',
								marginRight: 10,
								marginBottom: 0
							}}>
							{item.actionBtnName}
						</Button>
					)}
					<IconButton id="hide-preview-msg" size="small" onClick={() => onClose(item.id)}>
						<CloseIcon style={{ color: colors.PURPLE }} />
					</IconButton>
				</Box>
			</Box>
		);
	};

	if (isError) {
		return (
			<Box
				className={classes.msgBox}
				style={{
					background: isError ? colors.WARNING_COLOR : colors.ALERT_BG
				}}>
				<ErrorOccurred />
			</Box>
		);
	}

	return (
		<Fragment>
			{alertList.map((item, index) => {
				return <PrintAlertMsg key={index} item={item} />;
			})}
		</Fragment>
	);
};

export default Alert;
